import LocaleActions from "./LocaleActions";
import LocaleMutations from "./LocaleMutations";

const state = { locale: localStorage.getItem("locale") };

const { actions } = LocaleActions;

const { mutations } = LocaleMutations;

const namespaced = true;

export default {
	namespaced,
	state,
	actions,
	mutations,
};